import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import PlanetIcon from '../../../Components/Logos/Planet';
import SmsTemplateContent from '../Components/Templates/Sms';
import EmailTemplateContent from '../Components/Templates/Email';
import LandingPageTemplateContent from '../Components/LandingPages';

export const EDITORS = {
  TEMPLATES: EditRoundedIcon,
  MEDIA: DashboardCustomizeRoundedIcon,
  LANDING_PAGES: PlanetIcon,
};

export const CONTENT_WRAPPERS = {
  LANDING_PAGES: LandingPageTemplateContent,
  SMS: SmsTemplateContent,
  EMAIL: EmailTemplateContent,
};
